var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelicopterCorridorLightsL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 555,
    height: 637,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -231,
    y: 1653,
    width: 555,
    height: 637
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(231 -1653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-161.5 1937C-161.5 1816.88-64.1219 1719.5 56 1719.5 176.122 1719.5 273.5 1816.88 273.5 1937 273.5 2057.12 176.122 2154.5 56 2154.5-64.1219 2154.5-161.5 2057.12-161.5 1937Z",
    stroke: "#000000",
    strokeWidth: 52.7083,
    strokeMiterlimit: 8,
    fill: "#81F248",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 303,
    transform: "matrix(1 0 0 1 -48.8273 2028)"
  }, "H"))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelicopterCorridorLightsL);
export default __webpack_public_path__ + "static/media/HelicopterCorridorLightsL.b048ad645b7b193a0cf240dc07fa2295.svg";
export { ForwardRef as ReactComponent };